const OFF_PLATFORM_NOTE = 'Write your message here. NOTE- If you want to take your conversation off TogetherWe, be sure to provide your contact info here.';

export const en = {
  // Language toggle
  language: {
    english: 'English',
    spanish: 'Español',
  },

  // Navigation
  nav: {
    news: 'News',
    newsFeed: 'News Feed',
    events: 'Local Events',
    eventCalendar: 'Event Calendar',
    forums: 'Community Forums',
    resources: 'Resources',
    mentalHealthResources: 'Mental Health Resources',
    groups: 'Groups',
    groupsDirectory: 'Groups Directory',
    volunteers: 'Volunteer',
    volunteerDirectory: 'Volunteer Directory',
    providers: 'Providers',
    mentalHealthProviders: 'Mental Health Providers',
    residentDirectory: 'Resident Directory',
    blog: 'Blog',
    blogArticles: 'Blog Articles',
    welcome: 'Welcome',
    about: 'About TogetherWe',
    ourWork: 'Our Work',
    donate: 'Donate',
    frequentQuestions: 'Frequent Questions',
    guidelinesLegal: 'Guidelines & Legal',
    myProfile: 'My Profile',
    myGroups: 'My Groups',
    myEvents: 'My Events',
    menu: 'Menu',
    signIn: 'Sign In',
    signUp: 'Sign Up / Sign In',
    logOut: 'Log out',
  },

  // Create Button
  create: {
    create: 'Create',
    post: 'News Post',
    postDesc: 'Share with the community',
    event: 'Event',
    eventDesc: 'Create a community event',
    volunteer: 'Volunteer Opportunity',
    volunteerDesc: 'Post a volunteer opportunity',
    group: 'Group',
    groupDesc: 'Start a new community group',
    provider: 'Create Provider',
    providerDesc: 'Add a mental health provider',
    blog: 'Blog Post',
    blogDesc: 'Write an article for the community',
    resource: 'Resource',
    resourceDesc: 'Add a helpful resource',
    teamBio: 'Team Bio',
    teamBioDesc: 'Add a staff or board member',
    programCard: 'Program Card',
    programCardDesc: 'Add a work group card to Our Work',
    partnersSection: 'Partners Section',
    partnersSectionDesc: 'Edit logos shown on the Partners page',
  },

  // Common
  common: {
    scrollFiltersLeft: 'Scroll filters left',
    scrollFiltersRight: 'Scroll filters right',
    loading: 'Loading...',
    search: 'Search...',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving...',
    delete: 'Delete',
    deleting: 'Deleting...',
    edit: 'Edit',
    close: 'Close',
    submit: 'Submit',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    viewAll: 'View All',
    view: 'View',
    seeMore: 'See More',
    seeLess: 'See Less',
    noResults: 'No results found',
    required: 'Required',
    optional: 'Optional',
    all: 'All',
    free: 'Free',
    members: 'members',
    member: 'member',
    replies: 'replies',
    reply: 'Reply',
    likes: 'likes',
    like: 'Like',
    views: 'views',
    comments: 'comments',
    comment: 'Comment',
    share: 'Share',
    follow: 'Follow',
    following: 'Following',
    unfollow: 'Unfollow',
    join: 'Join',
    leave: 'Leave',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    admin: 'Admin',
    editor: 'Editor',
    anonymous: 'Anonymous',
    characters: 'characters',
    minRead: 'min read',
    justNow: 'just now',
    ago: 'ago',
    postedBy: 'Posted by',
    writtenBy: 'Written by',
    title: 'Title',
    category: 'Category',
    confirmDelete: 'Delete Blog?',
    deleteConfirmMessage: 'Are you sure you want to delete this blog? This action cannot be undone.',
    filters: 'Filters',
  },

  // Sidebar
  sidebar: {
    upcomingEvents: 'Upcoming Events',
    noUpcomingEvents: 'No upcoming events',
    viewAllEvents: 'View All Events',
    mentalHealthServices: 'Mental Health Services',
    forumTopics: 'Forum Topics',
    noForumTopics: 'No forum topics',
    viewAllTopics: 'View all Topics',
    volunteerJobs: 'Volunteer Jobs',
    noVolunteerJobs: 'No volunteer jobs',
    viewAllJobs: 'View all Jobs',
    gettingStarted: 'Getting Started',
    gettingStartedSubtitle: 'Everything you need to know about this platform.',
    communityGuidelines: 'Community Guidelines',
    frequentQuestions: 'Frequent Questions',
    aboutTogetherWe: 'About TogetherWe',
    popularGroups: 'Popular Groups',
    noPopularGroups: 'No groups yet',
    viewAllGroups: 'View all Groups',
    members: 'members',
    popularArticles: 'Popular Articles',
    noPopularArticles: 'No articles yet',
    minRead: 'min read',
    views: 'views',
  },

  // Crisis Banner
  crisis: {
    title: "You're not alone. Help is available.",
    getHelp: 'Get Help Now',
    findResources: 'Find Resources',
    advisory: "You're not alone. While this platform is a place for connection and resources, it is not monitored for crisis support and is not a substitute for professional care. If you are in crisis or need immediate help, please call or text 988, dial 911, or contact your local crisis hotline 208-788-3596 or Bilingual Support: 208-578-4114.",
    advisoryBold: ['text 988, dial 911', '208-788-3596', 'Bilingual Support: 208-578-4114.'],
    inappropriateLanguageWarning: "Please refrain from using inappropriate, hateful, or graphic content on TogetherWe. We don't allow this kind of content per our terms of service.",
    inappropriateTitle: 'Inappropriate Content',
    inappropriateAck: 'Got it',
    inappropriateBannerWarning: 'Please remove inappropriate, hateful, or graphic content before posting.',
  },

  // Auth Modal
  auth: {
    createAccount: 'Create your account',
    joinCommunity: 'Join the TogetherWe community today',
    welcomeBack: 'Welcome back',
    signInToContinue: 'Sign in to continue',
    yourName: 'Your name',
    email: 'Email address',
    password: 'Password',
    confirmPassword: 'Confirm password',
    location: 'Location',
    age: 'Age',
    continueWithGoogle: 'Continue with Google',
    continueWithApple: 'Continue with Apple',
    orContinueWith: 'or continue with email',
    signUp: 'Sign up',
    logIn: 'Log in',
    signIn: 'Sign In',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?",
    forgotPassword: 'Forgot password?',
    termsAgreement: 'By signing up, you agree to our',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    communityGuidelines: 'Community Guidelines',
    consentLabel: 'I have read and agree to the',
    consentRequired: 'You must agree to the Terms, Privacy Policy, and Community Guidelines to continue.',
    missingFieldsError: 'Error — You are missing required fields.',
    passwordRequirements: 'Password must be at least 8 characters',
    passwordMinLength: 'At least 10 characters',
    passwordReqNumber: 'At least one number',
    passwordReqSpecial: 'At least one special character',
    passwordReqUppercase: 'At least one uppercase letter',
    invalidEmail: 'Please enter a valid email address',
    passwordMismatch: 'Passwords do not match',
    ageRequirement: 'You must be at least 13 years old',
    ageConfirmation16Plus: '18+ years old',
    ageConfirmation13to15: '13-17 years old',
    birthdate: 'Birthdate',
    birthdateHelper: 'Required for ages 13-17. When you turn 18, your access will upgrade automatically.',
    birthdateFutureError: 'Birthdate cannot be in the future.',
    birthdateAgeRangeError: 'Birthdate must match an age between 13 and 17 years.',
    creatingAccount: 'Creating account...',
    loggingIn: 'Logging in...',
    failedToCreateAccount: 'Failed to create account',
    invalidCredentials: 'Invalid email or password',
    emailAlreadyRegistered: 'This email is already registered.',
    signInInstead: 'Sign in instead',
    accountSuspended: 'Your account has been suspended. Contact support.',
    profilePhoto: 'Profile photo',
    profilePhotoOptional: 'Optional',
    uploadPhoto: 'Upload photo',
    changePhoto: 'Change',
    resetPassword: 'Reset Password',
    resetPasswordTitle: 'Reset your password',
    resetPasswordDesc: 'Enter your email and we\'ll send you a code to reset your password',
    sendCode: 'Send Code',
    sendingCode: 'Sending...',
    verificationCode: 'Verification Code',
    enterCode: 'Enter the 6-digit code sent to your email',
    newPassword: 'New Password',
    resetPasswordButton: 'Reset Password',
    resettingPassword: 'Resetting...',
    backToLogin: 'Back to login',
    codeSent: 'Code sent! Check your email.',
    passwordResetSuccess: 'Password reset successfully! You can now log in.',
    invalidCode: 'Invalid or expired code',
    codeExpired: 'Code expired. Please request a new one.',
    changePassword: 'Change Password',
    changePasswordTitle: 'Change your password',
    changePasswordDesc: 'Enter your current password and choose a new one',
    currentPassword: 'Current Password',
    currentPasswordPlaceholder: 'Enter your current password',
    newPasswordPlaceholder: 'Enter your new password',
    confirmNewPassword: 'Confirm New Password',
    confirmNewPasswordPlaceholder: 'Re-enter your new password',
    passwordsDoNotMatch: 'New passwords do not match',
    changePasswordButton: 'Change Password',
    changingPassword: 'Changing...',
    passwordChangedSuccess: 'Password changed successfully! All other sessions have been revoked.',
    incorrectPassword: 'Current password is incorrect',
    passwordRequirementsNotMet: 'New password does not meet requirements',
    accountCreatedSuccess: 'Account created successfully!',
    loginSuccess: 'Login successful!',
  },

  // Home/News Page
  news: {
    title: 'News Feed',
    subtitle: 'Stay up to date with what\'s happening in your community',
    loadingNews: 'Loading news...',
    noNews: 'No news posts yet.',
    createFirst: 'Create the first post',
    reachedEnd: "You've reached the end",
    commentsUnavailable: "Comments couldn't be loaded. Refresh the page to try again.",
    searchPlaceholder: 'Search news...',
    whatsOnYourMind: "What's on your mind?",
    shareThoughts: 'Share your thoughts, updates, or announcements...',
    postingAsGroup: 'Posting as Group (Optional)',
    postingAsYou: 'Posting as You',
    selectGroup: 'Select a group to post on behalf of the organization',
    createPost: 'Post to News Feed',
    editPost: 'Edit Post',
    updatePost: 'Update Post',
    shareWithCommunity: 'Share something with the community',
    updateYourPost: 'Update your post',
    postCreated: 'Post created successfully!',
    postUpdated: 'Post updated successfully!',
    failedCreate: 'Failed to create post',
    failedUpdate: 'Failed to update post',
    deletePost: 'Delete Post?',
    deleteConfirm: 'This action will remove this post from the feed. This can be undone by an administrator.',
    imagesOptional: 'Images (Optional - Max 10)',
    dragDropImages: 'Drag and drop images here, or click to select',
    imagesAdded: 'images added',
    contentTooLong: 'Content too long',
  },
  // Events
  events: {
    title: 'Local Events',
    subtitle: 'Discover and join upcoming events in your community',
    searchPlaceholder: 'Search events by topic, group, location, and more\u2026',
    loadingEvents: 'Loading events...',
    noEvents: 'No events found.',
    createEvent: 'Create an Event',
    eventName: 'Event Name',
    addEventName: 'Add your event name',
    eventPhoto: 'Event Photo',
    addPhoto: 'Add a photo',
    date: 'Date',
    eventType: 'Event Type',
    oneOff: 'One off event',
    recurringDaily: 'Recurring daily',
    recurringWeekly: 'Recurring weekly',
    recurringBiWeekly: 'Recurring bi-weekly',
    recurringMonthly: 'Recurring monthly',
    startTime: 'Start Time',
    endTime: 'End Time',
    cost: 'Cost',
    enterTicketPrice: 'Enter ticket price',
    freeEvent: 'Free event',
    locationLabel: 'Location',
    enterLocation: 'Enter event location',
    bookingLink: 'Event Booking Link',
    bookingLinkPlaceholder: 'If you have an event booking page, add link here',
    addDetails: 'Add Details',
    describeEvent: 'Describe your event...',
    category: 'Category (Optional)',
    selectCategory: 'Select a category',
    eventAccess: 'Event Access',
    openToPublic: 'Open to Public',
    membersOnly: 'Members Only',
    anyoneCanRSVP: 'Anyone can RSVP to this event',
    onlyMembersRSVP: 'Only members of the group can RSVP to this event',
    postingAsGroup: 'Posting as Group',
    selectGroup: 'Select a group',
    mustBeAdmin: 'You must be an admin or editor of a group to create events',
    addEvent: 'Add Event',
    creating: 'Creating...',
    eventCreated: 'Event created successfully!',
    failedCreate: 'Failed to create event. Please try again.',
    errorCreating: 'An error occurred while creating the event.',
    pastDateError: 'Event date cannot be in the past. Please select a future date.',
    fillDetails: 'Fill in the details to create a new community event',
    upcomingEvents: 'upcoming events',
    allDates: 'All Dates',
    thisMonth: 'This Month',
    filterByDate: 'Filter by date',
    resetFilters: 'Reset All Filters',
    searchShortcuts: 'Search shortcuts',
    free: 'Free',
    eventImage: 'Event image',
    noUpcomingEvents: 'No upcoming events',
    attending: 'attending',
    viewEvent: 'View Event',
    nextMonth: 'Next Month',
    loadMoreEvents: 'Load More Events',
  },

  // Groups
  groups: {
    title: 'Groups Directory',
    subtitle: 'Find and join groups that match your interests',
    searchPlaceholder: 'Search groups by interest, population, and more\u2026',
    loadingGroups: 'Loading groups...',
    noGroups: 'No groups found.',
    createGroup: 'Create a Group',
    groupName: 'Group Name',
    enterGroupName: 'Enter group name',
    groupPhoto: 'Group Photo',
    description: 'Description',
    describeGroup: 'Describe your group...',
    categoryLabel: 'Category',
    acceptingMembers: 'Accepting New Members',
    allowJoinRequests: 'Allow people to request to join this group',
    createGroupBtn: 'Create Group',
    creating: 'Creating...',
    bringPeopleTogether: 'Create a new community group to bring people together',
    orDragDrop: 'or drag and drop',
    all: 'All',
    health: 'Health',
    healthcare: 'Healthcare',
    community: 'Community',
    nonprofit: 'Nonprofit',
    education: 'Education',
    educational: 'Educational',
    religious: 'Religious',
    other: 'Other',
    allCategories: 'All Categories',
    browseGroups: 'Browse groups to join',
    notMember: 'You are not a member of any groups yet.',
    manageGroups: 'Manage and interact with your groups',
    noDescription: 'No description available.',
    members: 'members',
    upcomingEvents: 'upcoming events',
    acceptingNewMembers: 'Accepting new members',
    groupIsFull: 'Group is full',
    removedFromFavorites: 'Removed from favorites',
    addedToFavorites: 'Added to favorites!',
    addToFavorites: 'Add to favorites',
    removeFromFavorites: 'Remove from favorites',
    categories: {
      outdoor: 'Outdoor',
      culture: 'Culture',
      business: 'Business',
      community: 'Community',
      education: 'Education',
      religious: 'Religious',
      support: 'Support',
      teens: 'Teens',
      seniors: 'Seniors',
      families: 'Families',
      singles: 'Singles',
    },
  },

  // My Groups
  myGroups: {
    title: 'My Groups',
    posts: 'News Feed',
    forum: 'Discussions',
    events: 'Events',
    videos: 'Videos',
    jobs: 'Jobs',
    members: 'Members',
    loadingGroups: 'Loading your groups...',
    signInToView: 'Please sign in to view your groups.',
    notMember: 'You are not a member of any groups yet.',
    browseGroups: 'Browse groups to join',
    manageGroups: 'Manage and interact with your groups',
    groupSelectorLabel: 'Your groups',
    scrollGroupsLeft: 'Scroll to previous groups',
    scrollGroupsRight: 'Scroll to more groups',
  },

  myEvents: {
    title: 'My Events',
    description: 'Keep track of the events you have RSVP’d to.',
    loadingEvents: 'Loading your events...',
    failedToLoad: 'Failed to load your events.',
    signInToView: 'Please sign in to view your events.',
    upcomingEvents: 'Upcoming Events',
    pastEvents: 'Past Events',
    noUpcomingEvents: 'No upcoming events yet',
    noUpcomingEventsDescription: 'Events you RSVP to with "I\'m Going" will appear here.',
    noPastEvents: 'No past events yet',
    noPastEventsDescription: 'Past events you attended will appear here once their date has passed.',
    browseEvents: 'Browse Events',
  },

  // Forums
  forums: {
    title: 'Community Forums',
    communityForums: 'Community Forums',
    searchPlaceholder: 'Search forum topics...',
    loadingTopics: 'Loading...',
    noTopics: 'No topics found',
    noTopicsFound: 'No topics found',
    askQuestion: 'Ask Question',
    askQuestionTitle: 'Ask a Question',
    enterQuestion: 'Enter your question and details below.',
    enterQuestionDetails: 'Enter your question and details below.',
    enterQuestionDetailsPlaceholder: 'Enter your question details',
    questionTitle: 'Title',
    enterQuestionTitle: 'Enter your question title',
    category: 'Category',
    categoryLabel: 'Category',
    selectCategory: 'Select a category',
    details: 'Details',
    enterDetails: 'Enter your question details',
    ask: 'Ask',
    posting: 'Posting...',
    questionPosted: 'Your question has been posted!',
    noReplies: 'No replies yet',
    noRepliesYet: 'No replies yet',
    shareThoughts: 'Share your thoughts...',
    selectUserToReply: 'Select a user to reply...',
    replyingTo: 'Replying to',
    replyTo: 'Reply to',
    replies: 'replies',
    reply: 'Reply',
    likes: 'likes',
    allCategories: 'All Categories',
  },

  // Volunteers
  volunteers: {
    title: 'Volunteer Opportunities',
    searchPlaceholder: 'Search volunteer opportunities...',
    loadingOpportunities: 'Loading opportunities...',
    noOpportunities: 'No volunteer opportunities found.',
    createJob: 'Create a Job',
    postOpportunity: 'Post a new volunteer opportunity for the community',
    postingAs: 'Posting as',
    selectGroupPlaceholder: 'Select a group...',
    jobName: 'Name of Job',
    enterJobTitle: 'Enter job title',
    uploadPhoto: 'Upload Photo',
    chooseFile: 'Choose File',
    pngJpgLimit: 'JPG, JPEG or PNG up to 5MB',
    descriptionLabel: 'Description',
    describeOpportunity: 'Describe the volunteer opportunity',
    locationLabel: 'Location',
    enterLocationPlaceholder: 'Enter location',
    startDate: 'Start Date',
    endDate: 'End Date',
    salary: 'Salary',
    salaryPlaceholder: 'e.g., $15/hour or Volunteer',
    jobType: 'Job Type',
    selectJobType: 'Select job type',
    positionsNeeded: 'Positions Needed',
    howManyVolunteers: 'How many volunteers do you need for this opportunity?',
    applicationLink: 'Application Link (Optional)',
    applicationLinkPlaceholder: 'https://example.com/apply',
    applicationLinkHelp: 'If provided, applicants will be directed to this link. Otherwise, they\'ll contact you via email.',
    createJobBtn: 'Create Job',
    jobCreated: 'Job created successfully!',
    failedCreate: 'Failed to create job',
    all: 'All',
    weekly: 'Weekly',
    biWeekly: 'Bi-weekly',
    monthly: 'Monthly',
    weekends: 'Weekends',
    flexible: 'Flexible',
    volunteersNeeded: 'volunteers needed',
    volunteerNeeded: 'volunteer needed',
    posted: 'Posted',
    linkCopied: 'Link copied to clipboard!',
    postOpportunityBtn: 'Post Opportunity',
    position: 'position',
    positions: 'positions',
    needed: 'needed',
    volunteerLabel: 'volunteer',
    volunteersLabel: 'volunteers',
    frequencies: {
      oneTime: 'One-time',
      daily: 'Daily',
      weekly: 'Weekly',
      biWeekly: 'Bi-weekly',
      monthly: 'Monthly',
      weekends: 'Weekends',
      flexible: 'Flexible',
    },
  },

  // Providers
  providers: {
    title: 'Mental Health Providers',
    subtitle: 'Find mental health providers in your area',
    searchPlaceholder: 'Search providers by focus areas, population served, or insurance types…',
    loadingProviders: 'Loading providers...',
    noProviders: 'No providers found.',
    allProviders: 'All Providers',
    filterByType: 'Filter by patient type',
    createProvider: 'Create a Provider',
    addToDirectory: 'Add a new mental health provider to the directory',
    providerName: 'Provider Name',
    enterProviderName: 'Enter provider name',
    uploadPhoto: 'Upload Photo',
    chooseFile: 'Choose File',
    pngJpgLimit: 'JPG, JPEG or PNG up to 5MB',
    degrees: 'Degrees / Licenses',
    selectDegree: 'Select degree',
    yearsExperience: 'Years of Experience',
    enterYears: 'Enter years',
    languages: 'Languages',
    sessions: 'Sessions',
    inPerson: 'In Person',
    virtual: 'Virtual',
    acceptingPatients: 'Accepting New Patients',
    waitlist: 'Not accepting new patients',
    specialties: 'My Specialties',
    selectSpecialties: 'Select specialties',
    maxSpecialties: '(max 3)',
    patients: 'My Patients',
    selectPatients: 'Select patient types',
    maxPatients: '(max 4)',
    locationLabel: 'Location',
    enterLocation: 'Enter location',
    phone: 'Phone',
    enterPhone: 'Enter phone number',
    email: 'Email',
    enterEmail: 'Enter email address',
    websiteLinkUrl: 'Website Link URL',
    sessionCost: 'Session Cost, Sliding Scale & Scholarships',
    officeHours: 'Office Hours',
    officeHoursPlaceholder: 'e.g., Mon-Fri: 9:00 AM - 5:00 PM',
    officeAddress: 'Office Address',
    enterFullAddress: 'Enter full address',
    insuranceAccepted: 'Insurance Accepted',
    typeToSearch: 'Type to search or add new',
    about: 'About',
    aboutPlaceholder: 'Tell potential patients about yourself, your approach, and your experience...',
    createProviderBtn: 'Create Provider',
    providerCreated: 'Provider created successfully!',
    failedCreate: 'Failed to create provider',
    yearsInPractice: 'years in practice',
    acceptingNewPatients: 'Accepting new patients',
    notAcceptingPatients: 'Not accepting new patients',
    addToFavorites: 'Add to favorites',
    removeFromFavorites: 'Remove from favorites',
    genderMale: 'Male',
    genderFemale: 'Female',
  },

  // Mental Health Resources
  resources: {
    title: 'Resources',
    topicAreaFilter: 'Topic Area',
    populationFilter: 'Population',
    searchPlaceholder: 'Search resources by topic area or population served…',
    call: 'Call',
    visitResource: 'Website',
  },

  // Blog
  blog: {
    title: 'Blog Articles',
    subtitle: 'Read articles and insights from the community',
    searchPlaceholder: 'Search blog posts...',
    loadingPosts: 'Loading blog posts...',
    noPosts: 'No blog posts found.',
    createBlog: 'Create Blog Post',
    writeArticle: 'Write an article for the community',
    blogTitle: 'Title',
    enterTitle: 'Enter blog title...',
    categoryLabel: 'Category',
    descriptionLabel: 'Description',
    briefSummary: 'Brief summary of the blog post...',
    content: 'Content',
    writeContent: 'Write your blog content here...',
    coverImage: 'Cover Image (Optional)',
    clickToUpload: 'Upload photo',
    featuredArticle: 'Featured Article',
    markAsFeatured: 'Mark as Featured Article',
    featuredHelp: 'Featured articles appear prominently at the top of the blog page. Only one article can be featured at a time.',
    saveAsDraft: 'Save as Draft',
    publishBlog: 'Publish Blog',
    saving: 'Saving...',
    draftSaved: 'Blog draft saved successfully!',
    blogCreated: 'Blog post created successfully!',
    failedCreate: 'We couldn\'t save your blog post. Please try again.',
    uncategorized: 'Uncategorized',
    draft: 'DRAFT',
    popularArticles: 'Popular Articles',
    categories: 'Categories',
    stayUpdated: 'Stay Updated',
    getLatestInsights: 'Get the latest community insights delivered to your inbox.',
    subscribe: 'Subscribe',
    thisIsFeatured: 'This article is now the featured article.',
    hideComments: 'Hide',
    showComments: 'Show',
    comments: 'comments',
    commenters: 'commenters',
    unlikeArticle: 'Unlike this article',
    likeArticle: 'Like this article',
    likes: 'likes',
  },



  // My Profile
  profile: {
    title: 'My Profile',
    editProfile: 'Edit Profile',
    saveChanges: 'Save',
    saving: 'Saving...',
    signInToView: 'Please sign in to view your profile.',
    name: 'Name',
    handle: 'Handle',
    usernameCannotChange: 'Username cannot be changed',
    emailCannotChange: 'Email address cannot be changed',
    neighborhood: 'Neighborhood',
    neighborhoodPlaceholder: 'Downtown Austin, TX',
    email: 'Email',
    allowContact: 'Allow people to contact me',
    deleteProfile: 'Delete Profile',
    deleteProfileWarning: 'Permanently delete your account and all associated data.',
    deleteProfileWarningLong: 'This action cannot be undone. All your data, posts, and activity will be permanently deleted.',
    deleteProfileConfirm: 'Delete Your Profile?',
    confirmDelete: 'Delete Profile',
    deleteProfileSuccess: 'Profile deleted successfully',
    deleteProfileFailed: 'Failed to delete profile',
    about: 'About',
    aboutPlaceholder: 'Tell us about yourself...',
    providerAccount: 'Mental Health Provider account',
    registeredProviderPrompt: 'Register as a Mental Health Provider',
    npiVerifiedLabel: 'NPI Verified',
    providerNumber: 'NPI Number',
    enterProviderNumber: 'Enter your NPI number',
    verified: 'Verified',
    providerVerified: 'NPI verified successfully!',
    providerVerifyFailed: 'Failed to verify NPI',
    providerNumberVerified: 'Your NPI has been verified.',
    createProviderProfile: 'Create Provider Profile',
    createProviderProfileDesc: 'Create a provider profile to be listed in the mental health provider directory.',
    npiVerification: {
      title: 'Verify NPI Number',
      subtitle: 'Verify your National Provider Identifier to confirm your credentials',
      enterNpi: 'NPI Number',
      npiHint: '10-digit National Provider Identifier',
      zipLabel: 'ZIP Code',
      zipHint: 'Enter your practice ZIP code',
      zipInvalid: 'Please enter a valid 5-digit ZIP code',
      verify: 'Verify NPI',
      verifying: 'Verifying with CMS Registry...',
      invalidFormat: 'Invalid NPI format. Must be 10 digits.',
      notFound: 'No provider found with this NPI number.',
      timeout: 'Request timed out. Please try again.',
      rateLimited: 'The registry is currently busy. Please try again in a few minutes.',
      error: 'An error occurred. Please try again.',
      tryAgain: 'Try Again',
      confirmSave: 'Confirm & Save',
      since: 'Since',
      notActive: 'This NPI is not active. Only active NPIs can be verified.',
      successTitle: 'Provider Verified!',
      successMessage: 'Your NPI has been verified and saved to your profile.',
      nameMismatch: 'The name on this NPI does not match your profile name. Please verify you entered the correct NPI number.',
      zipCodeMismatch: 'The location on this NPI does not match your profile location. You can still proceed if this is correct.',
    },
    emailNotifications: 'Email Notification Preferences',
    chooseNotifications: "Choose which email notifications you'd like to receive",
    dailySummary: 'Your Daily Summary',
    dailySummaryDesc: 'A daily summary of news posts and events',
    weeklySummary: 'Your Weekly Summary',
    weeklySummaryDesc: 'A weekly summary of news posts and events',
    groupUpdates: 'Group Updates',
    groupUpdatesDesc: 'New posts and events from groups you have joined',
    groupForumReplies: 'Group Forum Replies',
    groupForumRepliesDesc: 'Forum replies of groups you have joined',
    groupPostComments: 'Group Admin – Post Comments',
    groupPostCommentsDesc: "New comments on your group's News Feed",
    groupMemberRequests: 'Group Admin – Member Requests',
    groupMemberRequestsDesc: 'New member requests to your group',
    myGroupsSection: 'My Groups',
    noGroupsJoined: "You haven't joined any groups yet",
    noDescription: 'No description available.',
    showGroupsLabel: 'Display my groups on my profile',
    avatarUploading: 'Uploading photo...',
    avatarUploadSuccess: 'Profile photo updated!',
    avatarUploadFailed: 'Failed to upload photo',
  },

  // Users Page
  users: {
    title: 'Residents',
    subtitle: 'Connect with community members',
    searchPlaceholder: 'Search by name, username, or location...',
    loading: 'Loading residents...',
    noResidents: 'No residents available at this time.',
    noResultsFor: 'No residents found matching',
    tryDifferent: 'Try a different search term.',
    group: 'group',
    groups: 'groups',
    online: 'Online',
  },

  // Help Page
  help: {
    title: 'Get Help',
    searchPlaceholder: 'Search for answers...',
    emergencyContacts: 'Emergency Contacts',
    faq: 'Frequently Asked Questions',
    resources: 'Resources',
    crisisLine: 'Crisis Line',
    available247: 'Available 24/7',
    call: 'Call',
    noResults: 'No results found for',
    tryDifferent: 'Try a different search or',
    contactSupport: 'contact support',
    stillNeedHelp: 'Still need help?',
    supportTeam: 'Our support team is here to help you with any questions or issues you might have.',
    liveChat: 'Live Chat',
    emailSupport: 'Email Support',
  },

  // About Page
  about: {
    title: 'About TogetherWe',
    description: "We're building the future of community connection. TogetherWe empowers people to create, discover, and participate in meaningful communities that drive positive change in their local areas and beyond.",
    supportMission: 'Support our mission',
    supportDescription: 'TogetherWe relies on the generous financial support of individuals like you to maintain and expand our programs. Your donations help us provide essential community resources, host impactful events, connect volunteers with meaningful opportunities, and offer critical mental health services to those in need. Every contribution, no matter the size, makes a real difference in strengthening our community.',
    makeDonation: 'Make a donation',
    ourMission: 'Our Mission',
    missionText: 'To democratize community building by providing accessible tools that enable anyone to create, grow, and sustain meaningful connections. We believe that strong communities are the foundation of positive social change.',
    ourVision: 'Our Vision',
    visionText: 'A world where every person has access to communities that support their growth, amplify their voice, and help them create positive impact. We envision neighborhoods, cities, and regions connected through thriving digital communities.',
    byTheNumbers: 'By The Numbers',
    mentalHealthLandscape: 'Understanding the mental health landscape',
    strategicPlan: 'Our Strategic Plan',
    keyMilestones: 'Key milestones from 2025 to 2030',
    ourStaff: 'Our Staff',
    peopleBehind: 'The people behind TogetherWe',
    ourBoard: 'Our Board',
    leadersGuiding: 'Leaders guiding TogetherWe',
    joinNewsletter: 'Join Our Newsletter',
    newsletterDesc: 'Get monthly news and updates about all the initiatives that TogetherWe is involved with.',
    enterEmail: 'enter your email',
    viewArchive: 'View our archive of past newsletters.',
    ourStory: 'Our Story',
    ourTeam: 'Our Team',
    ourPartners: 'Our Partners',
    stayConnected: 'Stay connected with our community',
    subscribeBtn: 'Subscribe',
  },

  // Modals
  modals: {
    provider: {
      title: 'Create a Provider',
      subtitle: 'Add a new mental health provider to the directory',
      createProvider: 'Create a Provider',
      addNewProvider: 'Add a new mental health provider to the directory',
      providerName: 'Provider Name',
      enterProviderName: 'Enter provider name',
      uploadPhoto: 'Upload Photo',
      chooseFile: 'Choose File',
      pngJpgLimit: 'JPG, JPEG or PNG up to 5MB',
      fileTypes: 'JPG, JPEG or PNG up to 5MB',
      degrees: 'Degrees / Licenses',
      selectDegree: 'Select degree',
      yearsOfExperience: 'Years of Experience',
      enterYears: 'Enter years',
      languages: 'Languages',
      english: 'English',
      spanish: 'Spanish',
      sessions: 'Sessions',
      inPerson: 'In Person',
      virtual: 'Virtual',
      acceptingNewPatients: 'Accepting New Patients',
      waitlist: 'Not accepting new patients',
      mySpecialties: 'My Specialties',
      max: 'max',
      selectSpecialties: 'Select specialties',
      myPatients: 'My Patients',
      selectPatientTypes: 'Select patient types',
      location: 'Location',
      enterLocation: 'Enter location',
      phone: 'Phone',
      enterPhone: 'Enter phone number',
      email: 'Email',
      enterEmail: 'Enter email address',
      websiteLinkUrl: 'Website Link URL',
      cost: 'Cost',
      sessionCost: 'Session Cost, Sliding Scale & Scholarships',
      sessionCostPlaceholder: 'e.g. $150, $100-$150 sliding scale, scholarships available',
      officeHours: 'Office Hours',
      officeHoursPlaceholder: 'e.g., Mon-Fri: 9:00 AM - 5:00 PM',
      officeAddress: 'Office Address',
      enterFullAddress: 'Enter full address',
      insuranceAccepted: 'Insurance Accepted',
      typeToSearch: 'Type to search or add new',
      about: 'About',
      aboutPlaceholder: 'Tell potential patients about yourself, your approach, and your experience...',
      gender: 'Gender',
      genderMale: 'Male',
      genderFemale: 'Female',
      createProviderBtn: 'Create Provider',
      creating: 'Creating...',
      providerCreated: 'Provider created successfully!',
      providerCreatedSuccess: 'Provider created successfully!',
      failedCreate: 'Failed to create provider',
      failedToCreate: 'Failed to create provider',
    },
    blog: {
      createBlogPost: 'Create Blog Post',
      writeArticle: 'Write an article for the community',
      title: 'Title',
      enterBlogTitle: 'Enter blog title...',
      categories: 'Categories',
      selectUpToFour: 'select up to 4',
      categoriesSelected: '{count} of 4 categories selected',
      atLeastOneCategoryRequired: 'At least one category is required.',
      maxCategoriesReached: 'You can select up to 4 categories.',
      description: 'Description',
      briefSummary: 'Brief summary of the blog post...',
      content: 'Content',
      writeContent: 'Write your blog content here...',
      youtubeUrl: 'Video URL (YouTube or Vimeo, Optional)',
      youtubeUrlPlaceholder: 'Paste a YouTube or Vimeo link to embed in this article',
      youtubeUrlHelp: 'Supports YouTube (youtube.com, youtu.be) and Vimeo (vimeo.com) links.',
      invalidYoutubeUrl: 'Please enter a valid YouTube or Vimeo URL',
      minRead: 'min read',
      coverImage: 'Cover Image (Optional)',
      clickToUpload: 'Upload photo',
      markAsFeatured: 'Mark as Featured Article',
      featuredDescription: 'Featured articles appear prominently at the top of the blog page. Only one article can be featured at a time.',
      nowFeatured: 'This article is now the featured article.',
      saveAsDraft: 'Save as Draft',
      publishBlog: 'Publish Blog',
      saving: 'Saving...',
      creating: 'Creating...',
      draftSavedSuccess: 'Blog draft saved successfully!',
      blogCreatedSuccess: 'Blog post created successfully!',
      failedToCreate: 'We couldn\'t save your blog post. Please try again.',
      errorOccurred: 'An error occurred. Please try again.',
    },
    event: {
      createEvent: 'Create Event',
      fillDetails: 'Fill in the event details',
      postingAsGroup: 'Posting as Group',
      selectGroup: 'Select a group',
      selectGroupRequired: 'Select a group to post this event on behalf of',
      mustBeAdmin: 'You must be an admin or editor of a group to create events',
      eventName: 'Event Name',
      addEventName: 'Add your event name',
      eventPhoto: 'Event Photos',
      addPhoto: 'Add a photo',
      date: 'Date',
      endDate: 'End Date',
      eventType: 'Event Type',
      oneOff: 'One-off event',
      recurringDaily: 'Recurring daily',
      recurringWeekly: 'Recurring weekly',
      recurringBiWeekly: 'Recurring bi-weekly',
      recurringMonthly: 'Recurring monthly',
      startTime: 'Start Time',
      endTime: 'End Time',
      cost: 'Cost',
      costHint: 'Describe the cost in your own words — a price, "Free", "Pay what you can", or anything else.',
      costPlaceholder: 'e.g. $25, Free, Pay what you can, sliding scale',
      costRequired: 'Please describe the cost before saving.',
      location: 'Full Address',
      enterLocation: 'Enter Full Address',
      bookingLink: 'Event Booking Link',
      bookingLinkPlaceholder: 'If you have an event booking page, add link here',
      addDetails: 'Add Details',
      describeEvent: 'Describe your event...',
      categoryOptional: 'Category (Optional)',
      categoriesOptional: 'Categories (Optional)',
      selectUpToFour: 'Select up to 4',
      categoriesSelected: '{count} of 4 categories selected',
      selectCategory: 'Select a category',
      eventAccess: 'Event Access',
      openToPublic: 'Open to Public',
      membersOnly: 'Members Only',
      anyoneCanRsvp: 'Anyone can RSVP to this event',
      onlyMembersRsvp: 'Only members of the group can RSVP to this event',
      addEvent: 'Add Event',
      creating: 'Creating...',
      eventCreated: 'Event created successfully!',
      failedCreate: 'Failed to create event. Please try again.',
      errorCreating: 'An error occurred while creating the event.',
      pastDateError: 'Event date cannot be in the past. Please select a future date.',
      recurrenceEndRequired: 'Recurring events require an end date.',
      recurrenceEndAfterStart: 'End date must be on or after the event start date.',
    },
    news: {
      createPost: 'Create Post',
      editPost: 'Edit Post',
      shareWithCommunity: 'Share something with the community',
      updateYourPost: 'Update your post',
      postingAsGroup: 'Posting as Group (Optional)',
      postingAsGroupRequired: 'Posting as Group *',
      postingAsYou: 'Posting as yourself',
      selectGroup: 'Select a group',
      selectGroupToPost: 'Select a group to post on their behalf, or leave empty to post as yourself',
      selectGroupRequired: 'Select a group to post on their behalf',
      whatsOnYourMind: "What's on your mind?",
      sharePlaceholder: 'Share something with the community...',
      characters: 'characters',
      contentTooLong: 'Content is too long',
      imagesOptional: 'Images (Optional)',
      max: 'max',
      dragAndDrop: 'Click or drag and drop images',
      imagesAdded: 'images added',
      createPostBtn: 'Create Post',
      updatePost: 'Update Post',
      creating: 'Creating...',
      updating: 'Updating...',
      postCreated: 'Post created successfully!',
      postUpdated: 'Post updated successfully!',
      failedCreate: 'Failed to create post. Please try again.',
      failedUpdate: 'Failed to update post. Please try again.',
    },
    group: {
      createGroup: 'Create Group',
      createGroupSubtitle: 'Start a new community group',
      groupName: 'Group Name',
      enterGroupName: 'Enter group name',
      groupPhoto: 'Group Photo',
      groupPhotos: 'Group Photos',
      groupAvatar: 'Group Icon',
      groupAvatarHint: 'Shown next to your posts and as your group icon',
      addPhoto: 'Add Photo',
      addAvatar: 'Add Icon',
      orDragDrop: 'or drag and drop',
      description: 'Description',
      describeGroup: 'Describe your group...',
      aboutUs: 'About Us',
      tellUsMore: 'Tell us more about your group, its mission, and what members can expect...',
      category: 'Category',
      selectCategory: 'Select category',
      pickUpToCategories: 'Pick up to {n} categories',
      location: 'Location',
      websiteLink: 'Website Link',
      acceptingMembers: 'Accepting Members',
      groupIsFull: 'Group is Full',
      allowPeopleToJoin: 'Allow people to join this group',
      // MWBI-890 — the single Public/Private switch was replaced by two
      // independent visibility switches. Shared by the Create Group modal and
      // the Edit Group form so both screens name the settings identically.
      showMemberList: 'Show Member List',
      hideMemberList: 'Hide Member List',
      showGroupEvents: 'Show Group Events',
      hideGroupEvents: 'Hide Group Events',
      // Accessible names for the switches. Each is phrased as the ON-state
      // action so "switch, on" states the effect, not just the setting.
      toggleMemberListAria: 'Hide member list from non-members',
      toggleGroupEventsAria: 'Hide group events from non-members',
      toggleAcceptingMembersAria: 'Mark group as full',
      toggleApprovalModeAria: 'Auto-accept join requests',
      groupVisibilityNote: 'Each switch works on its own. Hidden lists are only hidden from people who are not members — members and group admins always see everything. Your group stays listed in the directory either way, and you can change these options any time in EDIT mode.',
      manualReview: 'Manual Review',
      autoAccept: 'Auto-Accept',
      memberApprovalNote: 'Manual Review requires you to approve each join request. Auto-Accept lets anyone join immediately.',
      createGroupBtn: 'Create Group',
      creating: 'Creating...',
      groupRulesLabel: 'Group Rules',
      rulesHint: 'You can add your own rules, but here are some to get you started!',
      defaultRulesText: "What participation here looks like:\n·          Be respectful and community-minded\n·          Keep content related to connection and mental well-being\n·          Be real and participate honestly\n·          Respect privacy and personal boundaries\n·          Be welcoming and help keep the community safe\n \nWhat is not allowed:\n·          Harassment, bullying or exclusionary behavior\n·          Hate speech or discrimination\n·          Impersonation or false representation\n·          Sharing private information or unsafe interactions\n·          Spam, harmful, or misleading content",
    },
    volunteer: {
      createJob: 'Create Volunteer Job',
      postNewOpportunity: 'Post a new volunteer opportunity',
      postingAs: 'Posting as Group',
      selectGroup: 'Select a group',
      nameOfJob: 'Name of Job',
      enterJobTitle: 'Enter job title',
      uploadPhoto: 'Upload Photo',
      chooseFile: 'Choose File',
      fileTypes: 'JPG, JPEG or PNG up to 5MB',
      description: 'Description',
      describeOpportunity: 'Describe the volunteer opportunity...',
      location: 'Location',
      enterLocation: 'Enter location',
      startDate: 'Start Date',
      endDate: 'End Date',
      startTime: 'Start Time',
      endTime: 'End Time',
      salary: 'Compensation',
      salaryPlaceholder: 'e.g., Volunteer, $15/hr',
      jobType: 'Job Type',
      selectJobType: 'Select job type',
      positionsNeeded: 'Positions Needed',
      numberOfVolunteers: 'Number of volunteers',
      howManyVolunteers: 'How many volunteers do you need?',
      applicationLink: 'Application Link',
      applicationLinkHelp: 'External link where volunteers can apply',
      createJobBtn: 'Create Job',
      creating: 'Creating...',
      jobCreatedSuccess: 'Volunteer job created successfully!',
      failedToCreate: 'Failed to create volunteer job. Please try again.',
      errorOccurred: 'An error occurred. Please try again.',
    },
    communityGuidelines: {
      title: 'TogetherWe Community Hub',
      subtitle: 'A place to connect, participate, and strengthen community across Blaine County.',
      lead: 'By joining, you agree to keep this space respectful, safe, and welcoming for everyone.',
      allowedHeading: 'What participation here looks like:',
      notAllowedHeading: 'What is not allowed:',
      allowed: [
        'Be respectful and community-minded',
        'Keep content related to connection and mental well-being',
        'Be real and participate honestly',
        'Respect privacy and personal boundaries',
        'Be welcoming and help keep the community safe',
      ],
      notAllowed: [
        'Harassment, bullying or exclusionary behavior',
        'Hate speech or discrimination',
        'Impersonation or false representation',
        'Sharing private information or unsafe interactions',
        'Spam, harmful, or misleading content',
      ],
      consentText: 'By clicking "I Agree" below, I consent to following these terms and conditions, including complying with all applicable rules, policies, and guidelines associated with this service. I acknowledge that my use of the platform is subject to these terms and that failure to adhere to them may result in restricted access or termination of my account.',
      agreeBtn: 'I Agree',
      saving: 'Saving...',
      viewFullLink: 'View full community guidelines and all terms & conditions',
      opensInNewTab: 'opens in a new tab',
      saveError: 'We couldn\'t record your acceptance. Please try again.',
    },
    ageVerification: {
      title: 'One quick question',
      lead: 'We ask for your age to ensure the right safety protections are in place for younger users. If you signed up with Google, you may not have been asked this question.',
      // The age label, both option labels, the "select one" error, the birthdate
      // label and its helper are deliberately NOT redefined here — this modal
      // reuses auth.age, auth.ageConfirmation13to15, auth.ageConfirmation16Plus,
      // errors.ageGroupRequired, auth.birthdate and auth.birthdateHelper so it
      // cannot drift from the signup form it mirrors.
      continueBtn: 'Continue',
      saving: 'Saving...',
      closeLabel: 'Close',
      errors: {
        BIRTHDATE_REQUIRED: 'Please enter your date of birth to continue.',
        BIRTHDATE_INVALID: 'That date doesn\'t look right. Please check it and try again.',
        BIRTHDATE_IN_FUTURE: 'That date is in the future. Please check it and try again.',
        AGE_OUT_OF_RANGE: 'TogetherWe is for ages 13 and up. Please check your date of birth.',
        SAVE_FAILED: 'We couldn\'t save your answer. Please try again.',
      },
    },
  },

  // Program Card modal
  translation: {
    sectionLabel: 'Spanish',
    statusAuto: 'Auto-translated',
    statusManual: 'Manual - edited by hand',
    statusPartial: 'Partly translated',
    statusUnavailable: 'Translation unavailable',
    statusPending: 'Translating...',
    explainAuto: 'This Spanish text is kept up to date automatically when you edit the English.',
    explainManual: "This item's Spanish no longer updates when you change the English.",
    explainPartial:
      'Some fields could not be translated. Spanish visitors see the English text for those.',
    explainUnavailable:
      "We couldn't translate this item. Spanish visitors are seeing the English text. Edit and save it again to retry.",
    explainPending: 'The Spanish version is being created and will appear in a few seconds.',
    editSpanish: 'Edit Spanish',
    cancelEditSpanish: 'Cancel Spanish edits',
    editWarning:
      'Editing the Spanish stops automatic updates for this item. From then on you maintain it by hand.',
    resetToAutomatic: 'Reset to automatic',
    resetHint: 'Clears your Spanish wording and lets the automatic translation take over again.',
    notTranslated: 'Not translated yet',
    markerLabel: 'No Spanish translation - visitors see English',
    emptyValue: '- not translated -',
  },
  programCard: {
    modalTitle: 'Create Program Card',
    tabLabel: 'Tab',
    tabPlaceholder: 'Select a tab',
    titleLabel: 'Title',
    titlePlaceholder: 'Enter program title',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Enter program description...',
    uploadPhoto: 'Upload Photo',
    chooseFile: 'Choose File',
    photoHint: 'PNG, JPG up to 10MB',
    cancel: 'Cancel',
    creating: 'Creating...',
    created: 'Program card created successfully!',
    updating: 'Updating...',
    updated: 'Program card updated successfully!',
    failed: 'Failed to create program card',
    editModalTitle: 'Edit Program Card',
    colorLabel: 'Card color',
    colors: {
      light: 'Light',
      cream: 'Cream',
      sage: 'Sage',
    },
    tabs: {
      collectiveImpact: 'Collective Impact',
      ourPrograms: 'Our Programs',
      fundingGrants: 'Funding & Grants',
      facilitatingSolutions: 'Facilitating Solutions',
    },
  },

  // Errors and Validation
  errors: {
    somethingWentWrong: 'Something went wrong',
    tryAgain: 'Please try again',
    networkError: 'Network error. Please check your connection.',
    unauthorized: 'You are not authorized to perform this action',
    notFound: 'Not found',
    serverError: 'Server error. Please try again later.',
    validationError: 'Please check your input and try again',
    requiredField: 'This field is required',
    invalidFormat: 'Invalid format',
    tooLong: 'Too long',
    tooShort: 'Too short',
    emailRequired: 'Please enter your email',
    emailInvalid: 'Please enter a valid email address',
    passwordRequired: 'Please enter a password',
    passwordTooLong: 'Password must be 72 characters or fewer',
    nameRequired: 'Please enter your full name',
    locationRequired: 'Please select your location',
    ageGroupRequired: 'Please select your age group',
    groupNameRequired: 'Please enter a group name',
    groupNameTooLong: 'Group name must be 100 characters or fewer',
    groupCategoryRequired: 'Please choose at least one category',
    groupAboutRequired: 'Please tell us about your group',
    groupDescriptionTooLong: 'Description must be 2000 characters or fewer',
    confirmPasswordRequired: 'Please confirm the password',
    bioTooLong: 'Bio must be 2000 characters or fewer',
    eventTitleTooLong: 'Event title must be 100 characters or fewer',
    eventDescriptionTooLong: 'Event description must be 5000 characters or fewer',
    blogTitleTooLong: 'Title must be 200 characters or fewer',
    blogDescriptionTooLong: 'Description must be 200 characters or fewer',
    blogContentTooLong: 'Content must be 50,000 characters or fewer',
    forumTitleRequired: 'Title is required',
    forumCategoryRequired: 'Category is required',
    forumReplyRequired: 'Reply body is required',
  },

  // Copy for the not-found.tsx boundaries. Deliberately no "try again" string:
  // a missing page is a permanent failure, and React Standards 11.3 reserves a
  // retry affordance for retryable errors.
  notFoundPage: {
    title: 'Page not found',
    description:
      'We could not find that page. The link may be incomplete, or the page may have been moved or removed.',
    goHome: 'Go to Home',
  },

  // Time
  time: {
    justNow: 'just now',
    minutesAgo: 'm ago',
    hoursAgo: 'h ago',
    daysAgo: 'd ago',
    minute: 'minute',
    minutes: 'minutes',
    hour: 'hour',
    hours: 'hours',
    day: 'day',
    days: 'days',
    week: 'week',
    weeks: 'weeks',
    month: 'month',
    months: 'months',
    year: 'year',
    years: 'years',
    ago: 'ago',
  },

  // Comments
  comments: {
    comment: 'comment',
    comments: 'comments',
    more: 'more',
    noComments: 'No comments yet',
    shareThoughts: 'Share your thoughts...',
    selectUserToComment: 'Select a user to comment...',
    replyingTo: 'Replying to',
    replyTo: 'Reply to',
  },

  // Group Tabs
  groupTabs: {
    posts: 'News Feed',
    loadingPosts: 'Loading posts...',
    noPosts: 'No posts yet in {groupName}',
    checkBackForPosts: 'Check back later for new posts!',
    mustBeMemberForum: 'You must be a member to view this forum',
    memberBenefits: 'As a member, you can participate in all in-person Group meetups and forum conversations.',
    startDiscussion: 'Start Discussion',
    postToForum: 'Post to {groupName} forum.',
    enterTopicTitle: 'Enter your topic title',
    selectCategory: 'Select a category',
    details: 'Details',
    enterTopicDetails: 'Enter your topic details',
    posting: 'Posting...',
    post: 'Post',
    discussions: 'Discussions',
    searchDiscussions: 'Search discussions...',
    noDiscussions: 'No discussions yet in {groupName}',
    beFirstToStart: 'Be the first to start a conversation!',
    deleteTopicTitle: 'Delete Topic',
    deleteTopicConfirm: 'Delete this topic? This action cannot be undone.',
    deleteReplyTitle: 'Delete Reply',
    deleteReplyConfirm: 'Delete this reply? This action cannot be undone.',
    mustBeMemberEvents: 'You must be a member to view events',
    upcomingEvents: 'Upcoming Events',
    hiddenEventsTitle: 'Events Hidden',
    onlyMembersCanViewEvents: 'Only group members can view these events',
    noUpcomingEvents: 'No upcoming events in {groupName}',
    checkBackLater: 'Check back later for new events!',
    mustBeMemberJobs: 'You must be a member to view job postings',
    jobPostings: 'Job Postings',
    noJobPostings: 'No job postings yet in {groupName}',
    checkBackForJobs: 'Check back later for new opportunities!',
    mustBeMemberVideos: 'You must be a member to view videos',
    videos: 'Videos',
    noVideos: 'No videos yet in {groupName}',
    checkBackForVideos: 'Check back later for new content!',
    members: 'Members',
    searchMembers: 'Search members...',
    noMembersFound: 'No members found',
    viewProfile: 'View Profile',
    replies: 'replies',
    reply: 'reply',
    views: 'views',
    view: 'view',
    addReply: 'Add a reply...',
    selectUserToReply: 'Select a user to reply...',
    replying: 'Replying...',
    noRepliesYet: 'No replies yet. Be the first to respond!',
    replyingTo: 'Replying to',
    posted: 'Posted',
    edited: 'Edited',
    addVideo: 'Add Video',
    noVideosYet: 'No videos yet',
    addFirstVideo: 'Add the first video!',
    invalidVideoUrl: 'Invalid video URL',
    invalidYoutubeUrl: 'Please enter a valid YouTube or Vimeo URL',
    youtubeUrl: 'Video URL (YouTube or Vimeo)',
    titleOptional: 'Title (Optional)',
    videoTitle: 'Video title',
    adding: 'Adding...',
    today: 'Today',
    oneDayAgo: '1 day ago',
    daysAgo: 'days ago',
    oneWeekAgo: '1 week ago',
    weeksAgo: 'weeks ago',
    requested: 'Requested',
    joined: 'Joined',
    accept: 'Accept',
    reject: 'Reject',
    memberRequests: 'Member requests',
    currentMembers: 'Current Members',
    noMembersYet: 'No members yet',
    replyTo: 'Reply to',
    rejectModalTitle: 'Reject member request',
    rejectModalSubtitle: 'Send a rejection message to {name}',
    rejectionReasonLabel: 'Reason',
    rejectionReasonPlaceholder: 'Explain why this request is being rejected...',
    rejectionReasonRequired: 'Please enter a reason before rejecting this request.',
    cancel: 'Cancel',
    rejectAndSend: 'Reject and Send Message',
    sendingRejection: 'Sending...',
    rejectSuccess: 'Request from {name} has been rejected and the rejection message was sent.',
    rejectFailed: 'Failed to reject member',
    rejectMessageFailed: 'Request from {name} was rejected, but the rejection message could not be sent. Please try again.',
    sendEmail: 'Send Email',
    selectedItems: 'selected',
    selectAllMembers: 'Select all current members',
    selectMember: 'Select {name}',
    bulkEmailModalTitle: 'Compose Email',
    bulkEmailModalSubtitle: 'Send an email to the selected group members',
    bulkEmailSubject: 'Subject',
    bulkEmailSubjectPlaceholder: 'Enter email subject...',
    bulkEmailMessage: 'Message',
    bulkEmailMessagePlaceholder: OFF_PLATFORM_NOTE,
    bulkEmailSend: 'Send',
    bulkEmailSending: 'Sending...',
    bulkEmailValidationError: 'Please fill in all required fields',
    bulkEmailSent: 'Email sent to {sentCount} members',
    bulkEmailSendFailed: 'Failed to send email. Please try again.',
    bulkEmailForbidden: 'You must be a group admin or MWBI admin to send emails.',
    ageTagAdult: 'Adult',
    ageTagTeen: 'Teen',
    bulkRemove: 'Remove',
    bulkRemoveConfirm: 'Remove {count} member(s) from this group?',
    bulkRemoveFailed: 'Failed to remove member(s). Please try again.',
    roleUpdateSuccess: '{name} is now {role}',
    roleUpdateFailed: 'Failed to update role. Please try again.',
    lastAdminError: 'At least one admin is required. Assign another admin first.',
  },
  groupDetail: {
    loginToFollow: 'Please log in to follow groups',
    unfollowed: 'Unfollowed {name}',
    nowFollowing: 'Now following {name}',
    joinedGroup: 'You have joined the group!',
    joinRequestSent: 'Join request sent! Awaiting admin approval.',
    failedToJoin: 'Failed to join group',
    loadingGroup: 'Loading group...',
    groupNotFound: 'Group not found',
    backToGroups: 'Back to Groups',
    founded: 'Founded',
    upcomingEvents: 'Upcoming Events',
    websiteLink: 'Website Link',
    visitWebsite: 'Visit website',
    notAcceptingMembers: 'Group is full',
    requesting: 'Requesting...',
    joinGroup: 'Join Group',
    joinConfirmMessage: 'Thank you for your interest in joining our group! All our members must agree to the rules of our group. Once you click Agree, our group admin will be able to approve your request.',
    joinConfirmAgree: 'Agree',
    joinRequestCanceled: 'Join request canceled',
    failedToCancelRequest: 'Failed to cancel request',
    requestPending: 'Request Pending',
    member: 'Member',
    unfollow: 'Unfollow',
    follow: 'Follow',
    linkCopied: 'Link copied to clipboard!',
    forum: 'Forum',
    jobs: 'Jobs',
    requested: 'Requested',
    joined: 'Joined',
    editGroup: 'Edit Group',
    deleteGroup: 'Delete Group',
    groupUpdated: 'Group updated successfully',
    // MWBI-890 — announced (role="status") while a save is in flight, and the
    // aria-describedby target for the four group-setting switches so their
    // disabled state has a stated reason.
    savingSettings: 'Saving your group settings…',
    groupDeleted: 'Group deleted successfully',
    failedToUpdate: 'Failed to update group',
    failedToDelete: 'Failed to delete group',
    deleteConfirmTitle: 'Delete Group',
    deleteConfirmMessage: 'Are you sure you want to delete this group? This action cannot be undone.',
    confirmDelete: 'Delete',
    saveChanges: 'Save Changes',
    cancelEdit: 'Cancel',
    aboutUs: 'About Us',
    groupRules: 'Group Rules',
    memberListHiddenTitle: 'Members List Hidden',
    onlyMembersCanViewMemberList: 'Only group members can view the member list',
  },
  eventDetail: {
    loadingEvent: 'Loading event...',
    eventNotFound: 'Event not found',
    // Names an incomplete link as a cause: the address is the one thing a
    // reader can check for themselves, and a shortened one is exactly how a
    // live event became unreachable in #1429.
    eventNotFoundDescription:
      'This event does not exist, or part of its web address is missing. Browse the calendar to find it.',
    backToEvents: 'Back to Events',
    joinGroupToViewTitle: 'Join Group to View',
    joinGroupToViewDescription: 'This event is private. Join the group to access the full event details.',
    joinGroupToViewEvent: '“{eventTitle}” is only available to approved members of this group.',
    membersOnly: 'Members Only',
    membersOnlyRsvp: 'This event is for group members only. Join the group to RSVP.',
    rsvpCancelled: 'RSVP cancelled',
    rsvpConfirmed: 'RSVP confirmed!',
    failedToUpdateRsvp: 'Failed to update RSVP',
    invalidDateTime: 'Invalid event date or time',
    removePhoto: 'Remove photo',
    updating: 'Updating...',
    cancelRsvp: "I'm not going",
    letFriendsKnow: 'I\u2019m Going',
    register: 'Register',
    addToCalendar: 'Add to Calendar',
    organizedBy: 'Organized By',
    eventOrganizer: 'Event Organizer',
    aboutThisEvent: 'About This Event',
    eventAgenda: 'Event Agenda',
    accessibilityInfo: 'Accessibility Information',
    location: 'Location',
    moreEvents: 'More Events',
    attendees: 'Attendees',
    noAttendeesYet: 'No attendees yet',
    postEvent: 'Post to News',
    editEvent: 'Edit Event',
    deleteEvent: 'Delete Event',
    saveChanges: 'Save Changes',
    cancelEdit: 'Cancel',
    eventUpdated: 'Event updated successfully',
    eventDeleted: 'Event deleted successfully',
    failedToUpdate: 'Failed to update event',
    failedToDelete: 'Failed to delete event',
    deleteConfirmTitle: 'Delete Event?',
    deleteConfirmMessage: 'Are you sure you want to delete this event? This action cannot be undone.',
    confirmDelete: 'Delete',
    recurrenceDeleteScopeTitle: 'Delete recurring event',
    recurrenceDeleteScopeDescription: 'Choose how much of this recurring series to delete.',
    recurrenceEditScopeTitle: 'Update recurring event',
    recurrenceEditScopeDescription: 'Choose how to apply these changes for this recurring series.',
    recurrenceScopeThisEvent: 'This event',
    recurrenceScopeThisEventDescription: 'Only the selected occurrence.',
    recurrenceScopeThisAndFuture: 'This and all future events',
    recurrenceScopeThisAndFutureDescription: 'The selected occurrence and every later occurrence in this series.',
    recurrenceScopeSelectionRequired: 'Select one option before continuing.',
    recurrenceEnds: 'Recurs {frequency} until {endDate}',
    eventEnded: 'This event has ended',
  },
  volunteerDetail: {
    opportunityNotFound: 'Opportunity not found.',
    backToVolunteers: 'Back to Volunteers',
    editOpportunity: 'Edit Opportunity',
    editingOpportunity: 'Editing Opportunity',
    noDescription: 'No description available.',
    contact: 'Contact',
    currentContactInfo: 'Current contact info',
    contactInfoManagedByProfile: 'Contact details come from the posting user profile and are not edited here.',
    position: 'position',
    positions: 'positions',
    needed: 'needed',
    oneTime: 'One-time',
    posted: 'Posted',
    updating: 'Updating...',
    applyNow: 'Apply Now',
    interested: 'RSVP',
    cancelInterested: 'Cancel RSVP',
    interestConfirmed: 'RSVP confirmed!',
    interestCancelled: 'RSVP cancelled',
    failedToUpdateInterest: 'Failed to update RSVP',
    interestedPeople: 'RSVPs',
    noInterestedYet: 'No RSVPs yet',
    zeroInterested: '0 RSVPs',
    interestedCountLabel: 'RSVPs',
    interestedInApplying: 'Interested in applying?',
    contactOrganizerDirectly: 'Contact the organizer directly to apply for this opportunity:',
    deleteOpportunity: 'Delete Opportunity',
    deleteOpportunityQuestion: 'Delete Opportunity?',
    deleteConfirmMessage: 'This action will remove this opportunity from the listing. This can be undone by an administrator.',
    opportunityUpdated: 'Opportunity updated successfully',
    failedToUpdate: 'Failed to update opportunity',
    failedToDelete: 'Failed to delete opportunity',
    noContactInfo: 'No contact information available',
    applicationSubject: 'Application',
    applicationBody: 'Hi,\n\nI\'m interested in applying for "{title}" at {organization}.\n\nPlease let me know the next steps.\n\nThank you!',
    aboutOpportunity: 'About',
    location: 'Location',
    forumTab: 'Forum',
    volunteersTab: 'Volunteers',
    noVolunteersYet: 'No volunteers yet',
    volunteerSingular: 'volunteer',
    volunteerPlural: 'volunteers',
  },
  providerDetail: {
    loadingProvider: 'Loading provider...',
    providerNotFound: 'Provider not found.',
    backToProviders: 'Back to Providers',
    editListing: 'Edit Listing',
    yearsInPractice: 'years in practice',
    virtual: 'Virtual',
    inPerson: 'In-person',
    acceptingNewPatients: 'Accepting new patients',
    waitlist: 'Not accepting new patients',
    notAcceptingPatients: 'Not accepting new patients',
    mySpecialties: 'My Specialties',
    myPatients: 'My Patients',
    phoneNumber: 'Phone Number',
    email: 'Email',
    websiteLink: 'Website Link',
    visitWebsite: 'Visit Website',
    cost: 'Cost',
    sessionCost: 'Session Cost, Sliding Scale & Scholarships',
    sessionCostPlaceholder: 'e.g. $150, $100-$150 sliding scale, scholarships available',
    officeHours: 'Office Hours',
    officeAddress: 'Office Address',
    insurance: 'Insurance',
    about: 'About',
    gender: 'Gender',
    myGender: 'My Gender',
    genderMale: 'Male',
    genderFemale: 'Female',
    favorite: 'Favorite',
    unfavorite: 'Unfavorite',
    addedToFavorites: 'Added to favorites!',
    removedFromFavorites: 'Removed from favorites',
  },
  blogDetail: {
    blogNotFound: 'Blog post not found.',
    backToBlog: 'Back to Blog',
    draft: 'DRAFT',
    notPublishedYet: 'This post is not published yet',
    editDraft: 'Edit Draft',
    editingDraft: 'EDITING DRAFT',
    saveDraft: 'Save Draft',
    saving: 'Saving...',
    publish: 'Publish',
    publishing: 'Publishing...',
    draftSaved: 'Draft saved successfully!',
    failedToSaveDraft: 'Failed to save draft',
    blogPublished: 'Blog published successfully!',
    failedToPublish: 'Failed to publish blog',
    deleteConfirm: 'Are you sure you want to delete this blog post? This action cannot be undone.',
    blogDeleted: 'Blog deleted successfully!',
    failedToDelete: 'Failed to delete blog',
    errorOccurred: 'An error occurred',
    coverImage: 'Cover Image',
    coverPreview: 'Cover preview',
    clickToUpload: 'Upload photo',
    title: 'Title',
    titlePlaceholder: 'Blog title...',
    description: 'Description',
    descriptionPlaceholder: 'Brief description...',
    content: 'Content',
    contentPlaceholder: 'Write your blog content here...',
    youtubeUrl: 'Video URL (YouTube or Vimeo)',
    youtubeUrlPlaceholder: 'Paste a YouTube or Vimeo link to embed in this article',
    youtubeUrlHelp: 'Supports YouTube (youtube.com, youtu.be) and Vimeo (vimeo.com) links.',
    invalidYoutubeUrl: 'Please enter a valid YouTube or Vimeo URL',
    featuredPost: 'Featured post',
    nowFeatured: 'This article is now the featured article.',
    moreArticles: 'More Articles',
    blogUpdated: 'Blog updated successfully!',
    failedToUpdate: 'Failed to update blog',
    editBlog: 'Edit Blog',
    editingBlog: 'Editing Blog',
    saveChanges: 'Save Changes',
  },
  userDetail: {
    loadingProfile: 'Loading resident profile...',
    userNotFound: 'Resident not found. Please check the URL or return to the directory.',
    backToDirectory: 'Back to Directory',
    follow: 'Follow',
    unfollow: 'Unfollow',
    messageMe: 'Message me',
    loginToFollow: 'Please log in to follow users',
    nowFollowing: 'Now following {name}',
    unfollowed: 'Unfollowed {name}',
    memberOf: 'Member of',
    group: 'Group',
    groups: 'Groups',
    notMemberOfAnyGroups: '{name} is not a member of any groups yet',
    noDescription: 'No description available.',
    member: 'member',
    members: 'members',
    upcoming: 'upcoming',
    event: 'event',
    events: 'events',
    admin: 'Admin',
    editor: 'Editor',
    directMessage: {
      modalTitle: 'Send Message',
      modalSubtitle: 'Send a direct email to {name}',
      subject: 'Subject',
      subjectPlaceholder: 'Enter message subject...',
      message: 'Message',
      messagePlaceholder: OFF_PLATFORM_NOTE,
      send: 'Send Message',
      cancel: 'Cancel',
      sending: 'Sending...',
      validationError: 'Please fill in all required fields',
      sent: 'Message sent to {name}',
      forbidden: 'Unable to send a message to this user.',
      recipientNotFound: 'Recipient not found.',
      sendFailed: 'Failed to send message. Please try again.',
    },
  },
  attendees: {
    zeroAttending: '0 attending',
    attending: 'attending',
  },
  imageCarousel: {
    previousImage: 'Previous image',
    nextImage: 'Next image',
    goToImage: 'Go to image {number}',
  },
  userSelector: {
    selectUser: 'Select User',
    devSwitchUser: 'DEV: Switch User',
    logOut: 'Log Out',
  },
  userManagement: {
    title: 'User Management',
    subtitle: 'Manage users, providers, and groups',
    allUsers: 'All Users',
    allProviders: 'All Providers',
    allGroups: 'All Groups',
    tabs: {
      users: 'Users',
      providers: 'Mental Health Providers',
      groups: 'Groups',
      archived: 'Archived',
    },
    searchPlaceholder: 'Search by name or location...',
    searchPlaceholderUsers: 'Search by name, location, or type...',
    table: {
      name: 'Name',
      accountAge: 'Account Age',
      recentActivity: 'Recent Activity',
      past12Months: 'Past 12 months',
      role: 'Role',
      userType: 'User Type',
      all: 'All',
      action: 'Action',
      actions: 'actions',
      featured: 'Featured',
      featuredTooltip: 'Marked as featured for the daily/weekly summary digest',
      notFeatured: 'Not featured',
    },
    activity: {
      high: 'High',
      medium: 'Medium',
      low: 'Low',
    },
    roles: {
      user: 'User',
      blogWriter: 'Blog Writer',
      admin: 'Admin',
      superadmin: 'Super Admin',
    },
    status: {
      active: 'Active',
      blocked: 'Blocked',
    },
    userType: {
      adult: 'Adult',
      teen: 'Teen',
      unknown: 'Unknown',
      unknownTooltip: 'Signed up before we asked for age; will be set on next sign-in',
    },
    actions: {
      select: 'Select',
      archive: 'Archive',
      unarchive: 'Unarchive',
      feature: 'Feature this group',
      unfeature: 'Unfeature this group',
      unblock: 'Unblock User',
      sendMessage: 'Send Message',
      sendEmail: 'Send Email',
      confirmAccount: 'Confirm Account',
      changePassword: 'Change Password',
    },
    badges: {
      unconfirmed: 'Unconfirmed',
    },
    messages: {
      archiveSuccess: 'Successfully archived',
      unarchiveSuccess: 'Successfully unarchived',
      featureSuccess: 'Group marked as featured',
      unfeatureSuccess: 'Group is no longer featured',
      unblockSuccess: 'User unblocked successfully',
      roleUpdated: 'Role updated successfully',
      errorUpdating: 'Error updating',
      emailSent: 'Email sent to {sentCount} users',
      emailSentWithFailures: 'Sent to {sentCount}, failed: {failedCount}',
      emailValidationError: 'Please fill in all required fields',
      emailAdminRequired: 'Admin access required',
      emailSendFailed: 'Failed to send email. Please try again.',
      directMessageSent: 'Message sent to {name}',
      directMessageForbidden: 'Unable to send a message to this user.',
      directMessageRecipientNotFound: 'Recipient not found.',
      directMessageSendFailed: 'Failed to send message. Please try again.',
      accountConfirmed: 'Account confirmed',
      confirmFailed: 'Could not confirm account. Please try again.',
      confirmForbiddenTarget: 'You cannot confirm this account.',
      confirmNotFound: 'User not found.',
      passwordChanged: 'Password changed',
      passwordChangeFailed: 'Could not change password. Please try again.',
    },
    adminChangePassword: {
      title: 'Change Password',
      subtitle: 'Set a new password for {name}',
      submit: 'Save Password',
      cancel: 'Cancel',
      fillAllFields: 'Please fill in both fields',
      errors: {
        selfTarget: 'Use your account settings to change your own password.',
        forbiddenTarget: "You cannot change this user's password.",
        tooWeak: 'Password must be at least 10 characters and include an uppercase letter, a number, and a special character.',
        userNotFound: 'User not found.',
      },
    },
    email: {
      modalTitle: 'Compose Email',
      modalSubtitle: 'Send an email to the selected users',
      subject: 'Subject',
      subjectPlaceholder: 'Enter email subject...',
      message: 'Message',
      messagePlaceholder: OFF_PLATFORM_NOTE,
      send: 'Send',
      cancel: 'Cancel',
      sending: 'Sending...',
    },
    directMessage: {
      modalTitle: 'Send Message',
      modalSubtitle: 'Send a direct email to {name}',
      subjectPlaceholder: 'Enter message subject...',
      messagePlaceholder: OFF_PLATFORM_NOTE,
      send: 'Send Message',
      cancel: 'Cancel',
      sending: 'Sending...',
    },
    empty: {
      noUsers: 'No users found',
      noProviders: 'No providers found',
      noGroups: 'No groups found',
      noArchived: 'No archived items',
    },
    confirmArchive: 'Are you sure you want to archive the selected items?',
    confirmUnarchive: 'Are you sure you want to unarchive the selected items?',
    selectedItems: 'selected',
    yearsMonths: '{years} years {months} months',
    yearMonths: '{years} year {months} months',
    months: '{months} months',
  },
  activityLog: {
    title: 'Activity Log',
    subtitle: 'Track all user and admin actions',
    searchPlaceholder: 'Search activities...',
    user: 'User',
    action: 'Action',
    dateTime: 'Date and Time',
    loadMore: 'Load more',
    noActivities: 'No activities found',
    // The search runs on the server across every entry (#1402); the hint says
    // so, because "nothing found" used to mean "not loaded yet".
    searchHint: 'Searches names and actions in the whole log. Up to {max} characters.',
    noSearchResults: 'No activities match your search.',
    showingCount: 'Showing {shown} of {total} activities',
    loadError: "We couldn't load the activity log. Please try again.",
    tryAgain: 'Try again',
  },
  flaggedItems: {
    title: 'Flagged Items',
    tabs: { posts: 'Posts', events: 'Events', groups: 'Groups', providers: 'Providers', jobs: 'Jobs', forums: 'Forums' },
    columns: { title: 'Title', issue: 'Flagged Issue', action: 'Action' },
    reports: 'reports',
    approve: 'Approve',
    dismiss: 'Dismiss',
    remove: 'Remove',
    flaggedBy: 'Flagged by',
    noItems: 'No flagged items',
    clickToView: 'Click to view',
    reasons: {
      inappropriate_language: 'Inappropriate language',
      harmful_content: 'Potentially harmful content',
      spam: 'Spam/Advertisement',
      self_harm: 'Self-harm mention',
      misinformation: 'Medical misinformation',
      harassment: 'Harassment',
      other: 'Other',
    },
    reportModal: {
      title: 'Report Content',
      subtitle: 'Why are you reporting this?',
      selectReason: 'Select a reason',
      submit: 'Submit Report',
      cancel: 'Cancel',
      success: 'Report submitted. Thank you for helping keep the community safe.',
      error: 'Failed to submit report',
    },
  },
  // FAQs Page
  faqs: {
    title: 'Frequent Questions',
    subtitle: 'Find answers to commonly asked questions about TogetherWe',
    searchPlaceholder: 'Search frequently asked questions...',
    categories: {
      platform: 'TogetherWe platform',
      profile: 'Managing my profile',
      community: 'Community features',
      groups: 'Groups features',
      mentalHealth: 'Mental Health features',
    },
    platform: [
      {
        question: 'What is the TogetherWe platform?',
        answer: 'TogetherWe is a community hub for everybody living in Blaine County. Here you will find all kinds of groups, organizations and activities that you can join. Connecting with others, and building community, is a great way to improve your mental well-being every day. You can learn more in the Groups FAQs. If you, or your family need professional help, you will find mental health providers and resources that can help you today. You can learn more in the Mental Health support FAQs.',
      },
      {
        question: 'Who can use it?',
        answer: 'All residents and organizations based in Blaine County. That includes service providers, schools, camps, sports teams, support groups, local government, non-profits and more.',
      },
      {
        question: 'How do you ensure the platform is friendly and welcoming?',
        answer: 'Our Community Guidelines lay out the way that we want people to use the platform. And the behaviors that are not allowed. Anybody who does not adhere to our guidelines will lose their access to the platform.',
      },
      {
        question: 'Are you tracking my information?',
        answer: 'We only track information for our own optimization reasons. We never sell your private data, and we don\'t use any data to target you. We have no incentive to use your data.',
      },
      {
        question: 'How old do you have to be to use the platform?',
        answer: 'We want to welcome everybody, including teens, to the platform. That said, we do limit it to users that are at least 13 years old.',
      },
      {
        question: 'How are you protecting kids on the platform?',
        answer: 'Any users that are under the age of 18 have added protections on the platform. They cannot receive any direct private communication from other users. Users under 16 can join groups, but not create a group, a news post or an event. And they can hide the groups they are a member of on their profile page.',
      },
      {
        question: 'What do you do to make content accessible for Spanish-speakers?',
        answer: 'All website content that is built into the platform is automatically translated through the English/Spanish language toggle located in the top right corner of the website. For user-generated content—such as newsfeed posts, events, group descriptions, comments, and other community contributions—users are responsible for providing any desired Spanish translations themselves. We encourage organizations and community members to post content in both English and Spanish whenever possible to maximize accessibility and engagement.',
      },
    ],
    profile: [
      {
        question: 'How do I edit my profile?',
        answer: 'Go to My Profile. Click or tap on the EDIT button. You can then edit your photo, name and bio here.',
      },
      {
        question: 'How do I delete my profile?',
        answer: 'Go to My Profile. Click or tap on the EDIT button. Then scroll down below your notification preferences and you will see the delete account button. WARNING — If you delete your account, all your data will be lost. If you ever create an account in the future, you will be starting over.',
      },
      {
        question: 'How do I manage my privacy?',
        answer: 'If you don\'t want others to see what groups you are a member of, scroll down in your profile to your groups. On the right, there is a toggle that you can turn on or off to hide them from displaying on your profile.',
      },
      {
        question: 'How do I report inappropriate content or behavior?',
        answer: 'All content — news posts, comments, events, groups, and mental health providers — has a flag button. If you click or tap the flag button, you can report inappropriate content to our moderators.',
      },
    ],
    community: [
      {
        question: 'How does the News Feed work?',
        answer: 'If you are a member of a group, or follow one, you will see their posts first. Then other posts will display in chronological order with the most recent at the top. You can comment on any post, and reply to others\' comments. Posts can directly link to events, groups or outside websites, which makes it very convenient to take action on things you are interested in. You can report any inappropriate posts by clicking on the flag button. This will notify our moderator.',
      },
      {
        question: 'How do I find and join Groups?',
        answer: 'Go to the Groups directory. Search for groups, or scroll through the listings. When you find one that looks interesting, click on its card to visit the group profile page.',
      },
      {
        question: 'How do I find and RSVP to Events?',
        answer: 'Go to the Events directory. Search, filter or browse Events. Click on an Event card to visit the Event detail page. If you find an event you are going to attend, click on the "I\'m Going" button. This saves the event into your My Events page, and enables you to ask questions in the event forum. If the event requires tickets, then click on the "Register" button to visit the ticketing page.',
      },
      {
        question: 'How do I find Articles?',
        answer: 'Go to the Blog directory. Search, filter or browse the blog articles. Click on any that interest you.',
      },
      {
        question: 'How can I find my friends and neighbors?',
        answer: 'Go to the Residents directory. Search for your friends and neighbors by name. If they have an account, their card will appear in the results.',
      },
    ],
    groupsFeatures: [
      {
        question: 'What are Groups?',
        answer: 'Groups are community spaces where residents and organizations connect around shared interests, activities, or causes. As a group member, you can participate in group forums, attend group events, and receive updates from group administrators.',
      },
      {
        question: 'Who can create a Group?',
        answer: 'Any resident, and any organization, can create a group — however we do limit it to users who are over 16 and live in Blaine County. Creating a group comes with some responsibility. Group admins have to manage the conversation in their group forum, and ensure that everybody is kind and respectful to each other. Groups should be about connection. They are not to be used for any activities that go against our Community Guidelines and our Terms and Conditions.',
      },
      {
        question: 'How do you create a Group?',
        answer: 'Simply click or tap the white "+ Create" button in the top bar. Then select "Create Group". A form will appear. You will need a name and a description. PRO TIP: Add some photos — people are visual. And to make your photo look as good as possible in your Group Card, use the Aspect Ratio of 600x800 landscape. We provide some basic rules of conduct in your description. You can add anything else, but we ask that you don\'t delete the rules. Public groups share their upcoming meetups, events, and member list on their page. Private groups hide these.',
      },
      {
        question: 'How do I establish rules for my Group?',
        answer: 'You want to ensure that your group is a great environment, and not a bickering disaster. Setting a few rules for everybody can ensure you avoid most issues. If you don\'t know where to start, we provide some basic rules of conduct in every group description. You can add anything else, but we ask that you establish some basic rules that every member must agree to. Then, if anybody breaks the rules, you can remove them from the group, and everybody will understand why.',
      },
      {
        question: 'How do I invite people to join my Group?',
        answer: 'If you have an email list of friends or co-workers that you want to invite to your group, simply click the "Share" button, which saves the URL of your group, and paste it into your email or text. Anybody who visits your group page can click the "Join" button.',
      },
      {
        question: 'How do I manage my Group communications?',
        answer: 'When you create a group, you become the admin of that group. As the admin, you have certain privileges — you can create posts, create events, and accept or reject members. You can also create or delete group forum discussions. Any of your group members who have their email notification turned on will automatically receive a summary of the group posts and events. A group provides you with the power of social media, email newsletters and meetups — combined.',
      },
      {
        question: 'How do I create an Event?',
        answer: 'Click or tap the white "+ Create" button in the top bar. Then select "Create Event" from the dropdown list. A popup form will appear. At the top, you can select what group you are posting as. Then fill in the form, adding name, details, dates and times, etc. PRO TIP: When adding photos, to make your first photo look as good as possible in your Event Card, use the Aspect Ratio of 600x800 landscape. You can create a one-off event, or a recurring event. And you can create a public event, or a members-only meetup. When it is ready, click Create. You can also post your event to the News Feed any time by clicking on the "Post to News Feed" button at the top of the event page.',
      },
      {
        question: 'How do I create a News Post?',
        answer: 'Click or tap the white "+ Create" button in the top bar. Then select "Create Post" from the dropdown list. A popup form will appear. At the top, you can select what group you are posting as. Then you can add whatever message you want. You can include links in your message — simply copy and paste them into the text field. This is a valuable feature that allows you to share any webpage on the internet. Please make sure you only share appropriate content per our Community Guidelines and Terms and Conditions.',
      },
      {
        question: 'How do I manage my Group members?',
        answer: 'In the members tab, you can change a member\'s status to admin, giving them the same privileges as you. This is helpful if you are running a larger organization and need help with running the group, creating posts, and creating events. Any admin can message one or multiple group members — helpful to send out reminders or alert them to updates. Admins can also remove members that don\'t adhere to the rules. Only make others admins that you can trust. If you ever want to leave a Group that you started, you will need at least one other Admin to hand over the reins to.',
      },
      {
        question: 'Can I have multiple Groups?',
        answer: 'Yes! You can create as many groups as you want. And you can join as many as you want too. We feel that having multiple groups ensures that you become an active member of the community — and lead a rich and fulfilling life.',
      },
      {
        question: 'What is the My Groups page?',
        answer: 'To make it easier to manage your group, and others, we designed the My Groups page. This page pulls in all your group communication into one handy place. It also works for groups you are a member of. Everything is right there in My Groups.',
      },
      {
        question: 'What are the best photo dimensions for the Group and Events cards?',
        answer: 'If you want the image to look best on the cards, you can crop it to a 3x4 aspect ratio. So an image that is 600x800px would work well.',
      },
      {
        question: 'Email your Group members',
        answer: 'As an Admin, you can send a one-way message to one, some, or all your members. First, go to your Members tab. Then, click the checkbox next to their name to select the member(s) you want to email. This will display a "Send Email" button. When you click this button, you will get a popup to fill in the Subject and the Message and send it. Please note, members cannot respond to this email so you may want to include your contact information.',
      },
    ],
    mentalHealth: [
      {
        question: 'How do I find a Mental Health Provider?',
        answer: 'Go to the Mental Health Provider directory. Search, filter or browse the provider cards. Click on one to view their provider page. You can search by all kinds of ways — by insurance they take, by specialty, by gender, by type of session (virtual or in-person) they offer, and whether they are accepting new patients.',
      },
      {
        question: 'How do I contact a Mental Health Provider?',
        answer: 'On their provider page, they list their contact information — usually email or phone. They also may list a website where you can book an appointment.',
      },
      {
        question: 'How do I find Mental Health Resources?',
        answer: 'Go to the Mental Health Resources directory. Search, filter or browse the resource cards. When you search, you will pull up resources and articles related to your search. The resource cards have a link out to a website. Some might also have a direct number to call.',
      },
      {
        question: 'How do I get help right now?',
        answer: 'If you are looking for immediate help, you can find crisis support in the top cards of the Mental Health Resources directory.',
      },
      {
        question: 'How do I register as a Mental Health Provider?',
        answer: 'If you are a Mental Health Provider, go to My Profile page. Scroll down to the bottom. There, you will find a box with the title Register as a Mental Health Provider. Click on the Verify NPI button then enter your NPI number and zip code. NOTE: Your NPI number, name, and zipcode must match what is in the NPI Registry. This might take a few seconds. Once you are verified, your status in the app will be updated.',
      },
      {
        question: 'How do I create a Mental Health Provider page?',
        answer: 'Once you are registered as a Mental Health Provider, you can create your page. Simply click on the Create button on the top bar. You should see Provider Page as an option - click on that to open the form. The form will ask you for a number of items, like a photo, your licenses and degrees, specialties, and the insurance you accept. Once you enter all your information, and submit, you should see your Provider page. Review it. If you want to change anything, you simply click on the Edit button at the top right of the page. You can then add or change anything, and save your changes.',
      },
      {
        question: 'What are the best photo dimensions for the Mental Health Provider cards?',
        answer: 'If you want the image to look best on the cards, you can crop it to a 3x4 aspect ratio. So an image that is 600x800px would work well.',
      },
    ],
  },

  // Guidelines & Legal page
  guidelinesLegal: {
    title: 'Guidelines & Legal',
    lastUpdated: 'Last Updated',
    tabs: {
      communityGuidelines: 'Community Guidelines',
      terms: 'Terms & Conditions',
      privacy: 'Privacy Policy',
    },
  },

  // Site footer (MWBI-901). Labels only. The organization name, EIN, mailing
  // address and contact email are untranslated constants in
  // `frontend/src/lib/org-contact.ts` and must never move into this namespace --
  // a translator would have no way to know an EIN is not copy. Locked by the
  // negative assertions in Footer.test.tsx and org-contact.test.ts.
  footer: {
    logoAlt: 'TogetherWe - United for Mental Well-Being',
    contactLabel: 'Contact:',
    builtByLabel: 'Built by:',
    copyright: 'Copyright ©',
  },

  // Slug-keyed labels for taxonomies (filter dropdowns, category/specialty chips).
  // Keys mirror the canonical slug/value used by the source-of-truth constants.
  // Lookup helpers in `frontend/src/lib/taxonomy-labels.ts` fall back to the
  // hardcoded English label when a key is missing.
  taxonomy: {
    common: {
      all: 'All',
    },
    groupCategories: {
      'arts-culture': 'Arts/Culture',
      business: 'Business',
      community: 'Community',
      education: 'Education',
      games: 'Games',
      'health-wellness': 'Wellness/Self-Care',
      'hobbies-interests': 'Hobbies/Interests',
      multicultural: 'Multicultural',
      nonprofit: 'Nonprofit',
      'outdoor-recreation': 'Outdoor/Recreation',
      'pets-animals': 'Pets/Animals',
      'religion-spirituality': 'Religion/Spirituality',
      'social-activities': 'Social Activities',
      'sports-fitness': 'Sports/Fitness',
      'support-coaching': 'Support/Coaching',
      travel: 'Travel',
      volunteering: 'Volunteering',
    },
    providerFilters: {
      adhd: 'ADHD',
      adults: 'Adults',
      anxiety: 'Anxiety',
      'bipolar-disorder': 'Bipolar Disorder',
      couples: 'Couples',
      depression: 'Depression',
      'eating-disorders': 'Eating Disorders',
      families: 'Families',
      'grief-loss': 'Grief/Loss',
      lgbtqia: 'LGBTQIA+',
      ocd: 'OCD',
      'otr-l': 'Occ. Therapy (OT)',
      'seniors-elderly': 'Seniors/Elderly',
      'sexual-trauma': 'Sexual Trauma',
      'substance-use': 'Substance Use',
      'suicide-ideation': 'Suicide Ideation',
      'adolescents-teens': 'Teens/Adolescents',
      'trauma-ptsd': 'Trauma/PTSD',
    },
    providerSpecialties: {
      Anxiety: 'Anxiety',
      Depression: 'Depression',
      'Trauma/PTSD': 'Trauma/PTSD',
      ADHD: 'ADHD',
      'Bipolar Disorder': 'Bipolar Disorder',
      'Eating Disorders': 'Eating Disorders',
      'Substance Abuse': 'Substance Abuse',
      'Substance Use': 'Substance Use',
      OCD: 'OCD',
      'Grief/Loss': 'Grief/Loss',
      'Relationship Issues': 'Relationship Issues',
      'Family Therapy': 'Family Therapy',
      'Child & Adolescent': 'Child & Adolescent',
      'LGBTQ+': 'LGBTQ+',
      'LGBTQIA+': 'LGBTQIA+',
      'Sexual Trauma': 'Sexual Trauma',
      'Suicide Ideation': 'Suicide Ideation',
      Other: 'Other',
    },
    resourceTopics: {
      crisis: 'Crisis',
      'death-and-dying': 'Death/Dying',
      'domestic-violence': 'Domestic Violence',
      'education-training': 'Education/Training',
      'financial-support': 'Financial Support',
      food: 'Food',
      grief: 'Grief/Loss',
      'higher-levels-of-mental-health-care': 'Higher Levels of Care',
      housing: 'Housing',
      neurodiversity: 'Neurodiversity',
      'substance-use': 'Substance Use',
      suicide: 'Suicide',
      wellness: 'Wellness/Self-Care',
    },
    resourcePopulations: {
      adults: 'Adults',
      'families-parents': 'Families/Parents',
      'first-responders': 'First Responders',
      hispanic: 'Hispanic',
      'latino-latina': 'Latino/Latina',
      'lgbtqia-plus': 'LGBTQIA+',
      'mental-health-providers': 'Mental Health Providers',
      seniors: 'Seniors',
      teens: 'Teens',
      veterans: 'Veterans',
    },
    resourceCategories: {
      adults: 'Adults',
      crisis: 'Crisis',
      'death-and-dying': 'Death/Dying',
      'domestic-violence': 'Domestic Violence',
      'education-training': 'Education/Training',
      'families-parents': 'Families/Parents',
      'financial-support': 'Financial Support',
      'first-responders': 'First Responders',
      food: 'Food',
      grief: 'Grief/Loss',
      'higher-levels-of-care': 'Higher Levels of Care',
      hispanic: 'Hispanic',
      housing: 'Housing',
      'latino-latina': 'Latino/Latina',
      'lgbtqia-plus': 'LGBTQIA+',
      'mental-health-providers': 'Mental Health Providers',
      neurodiversity: 'Neurodiversity',
      seniors: 'Seniors',
      'substance-use': 'Substance Use',
      suicide: 'Suicide',
      teens: 'Teens',
      veterans: 'Veterans',
      wellness: 'Wellness/Self-Care',
    },
    // Keyed by blog-category slug. CMS-driven; falls back to category.name
    // when a slug isn't present here (e.g. admin-added categories without
    // a translation yet).
    blogCategories: {
      adults: 'Adults',
      'arts-culture': 'Arts/Culture',
      'community-building': 'Community',
      crisis: 'Crisis',
      'death-and-dying': 'Death/Dying',
      'domestic-violence': 'Domestic Violence',
      education: 'Education/Training',
      'en-espanol': 'en español',
      events: 'Events',
      families: 'Families/Parents',
      'financial-support': 'Financial Support',
      'first-responders': 'First Responders',
      food: 'Food',
      grief: 'Grief',
      'higher-levels-of-care': 'Higher Levels of Care',
      housing: 'Housing',
      lgbtq: 'LGBTQIA+',
      'mental-health': 'Mental Health',
      multicultural: 'Multicultural',
      neurodiversity: 'Neurodiversity',
      nonprofit: 'Nonprofit',
      outdoor: 'Outdoor/Recreation',
      religion: 'Religion/Spirituality',
      seniors: 'Seniors',
      'sports-fitness': 'Sports/Fitness',
      'substance-use': 'Substance Use',
      suicide: 'Suicide',
      'support-coaching': 'Support/Coaching',
      teens: 'Teens',
      'together-we': 'TogetherWe',
      veterans: 'Veterans',
      volunteer: 'Volunteer',
      wellness: 'Wellness/Self-Care',
    },
    // Keyed by event-category slug. CMS-driven; falls back to category.name
    // when a slug isn't present here (e.g. admin-added categories without
    // a translation yet).
    eventCategories: {
      adults: 'Adults',
      'arts-culture': 'Arts/Culture',
      community: 'Community',
      'education-training': 'Education/Training',
      'family-friendly': 'Family Friendly',
      free: 'Free',
      games: 'Games',
      kids: 'Kids',
      multicultural: 'Multicultural',
      nonprofit: 'Nonprofit',
      outdoor: 'Outdoor',
      pets: 'Pets',
      religion: 'Religion',
      seniors: 'Seniors',
      'substance-free': 'Substance-Free',
      'support-coaching': 'Support/Coaching',
      teens: 'Teens',
      volunteer: 'Volunteer',
      'wellness-self-care': 'Wellness/Self-Care',
    },
  },
} as const;

